import { Icon } from "@iconify/react";
import { Typography } from "antd";
import moment from "moment";
import { MouseEventHandler } from "react";
import { appendSasToken } from "~/Modules/Centralized/Forms/Imagehelper";
import approvalManagementPending from "../Assets/SVG/approval_management_pending.svg";

export const renderDateColumn = (value: any) => {
  return value ? (
    <Typography.Text>{moment.utc(value).format("DD MMM YYYY hh:mm:ss A")}</Typography.Text> //getFormattedDate(value)
  ) : (
    <Typography.Text disabled>-</Typography.Text>
  );
};

export const renderDDMMMYYYYFormat = (value: any) => {
  return value ? (
    <Typography.Text>{moment.utc(value).format("DD MMM YYYY")}</Typography.Text>
  ) : (
    <Typography.Text disabled>-</Typography.Text>
  );
};

export const renderPublishedColumn = (value: any) => {
  return value ? <Typography.Text>Yes</Typography.Text> : <Typography.Text>No</Typography.Text>;
};

export const renderPublishedColumnStatus = (value: any) => {
  const normalized = String(value).toLowerCase(); // normalize all forms
  const isPublished = normalized === "true";
  return <Typography.Text>{isPublished ? "Yes" : "No"}</Typography.Text>;
};

export const renderImageColumn = (imageData: string | string[]) => {
  if (!imageData) {
    return null;
  }
  console.log("imageeeeeeeeeesss -daata", imageData);
  // Handle different input types and convert to array of URLs
  let imageUrls: string[];
  if (Array.isArray(imageData)) {
    imageUrls = imageData;
    console.log("imageeeeeeeeeesss -1", imageUrls);
  } else if (imageData.includes("http") && !imageData.includes(",")) {
    imageUrls = [imageData];
    console.log("imageeeeeeeeeesss -2", imageUrls);
  } else {
    // imageUrls = imageData.split(",").map(url => url.trim());
    imageUrls = imageData
      .split(", ")
      .map((url) => url.trim())
      .filter((url) => url.startsWith("http"));
    console.log("imageeeeeeeeeesss -3", imageUrls);
  }

  if (imageUrls.length > 1) {
    return (
      <div className="flex space-x-2 overflow-x-auto">
        {imageUrls.map((url, index) => (
          <img
            key={index}
            src={url}
            alt={`Brand ${index + 1}`}
            className="w-14 h-14 object-cover flex-shrink-0"
          />
        ))}
      </div>
    );
  } else if (imageUrls.length === 1) {
    return (
      <img
        src={imageUrls[0]}
        alt="Brand"
        className="w-14 h-14 object-cover"
      />
    );
  } else {
    return null;
  }
};

export const renderImageSasToken = (imageData: string | string[]) => {
  if (!imageData) return null;

  let imageUrls: string[];

  if (Array.isArray(imageData)) {
    imageUrls = imageData;
  } else if (imageData.includes("http") && !imageData.includes(",")) {
    imageUrls = [imageData];
  } else {
    imageUrls = imageData
      .split(", ")
      .map((url) => url.trim())
      .filter((url) => url.startsWith("http"));
  }

  const sasImageUrls = imageUrls.map((url) => appendSasToken(url)).filter(Boolean) as string[];

  if (sasImageUrls.length > 1) {
    return (
      <div className="flex space-x-2 overflow-x-auto">
        {sasImageUrls.map((url, index) => (
          <img
            key={index}
            src={url}
            alt={`Banner ${index + 1}`}
            className="w-14 h-14 object-cover flex-shrink-0"
          />
        ))}
      </div>
    );
  }

  if (sasImageUrls.length === 1) {
    return (
      <img
        src={sasImageUrls[0]}
        alt="Banner"
        className="w-14 h-14 object-cover"
      />
    );
  }

  return null;
};

export const renderActionsColumn = (
  record: any,
  setSelectedRowData?: (record: any) => void,
  setDrawerVisible?: (visible: boolean) => void,
  navigateToEditPage?: MouseEventHandler<SVGSVGElement>,
  setSelectedId?: (Id: any) => void,
  setDeleteModalVisible?: (visible: boolean) => void,
  name?: string
) => {
  return (
    <div className="flex gap-2">
      {name !== "approvalManagement" ? (
        <Icon
          height={25}
          icon={"iconamoon:eye"}
          className="text-blue-600 border border-blue-600 rounded-full p-0.5"
          onClick={(e) => {
            e.preventDefault();
            setSelectedRowData?.(record);
            setDrawerVisible?.(true);
          }}
        />
      ) : (
        <img
          src={approvalManagementPending}
          alt="Approval Management Pending"
          height={25}
          className="border border-blue-600 rounded-full p-0.5"
          onClick={(e) => {
            e.preventDefault();
            setSelectedRowData?.(record);
            setDrawerVisible?.(true);
          }}
        />
      )}
      {record?.status !== "PENDING" &&
        record?.status !== "REJECTED" &&
        record?.status !== "APPROVED" &&
        record?.status !== "pending" &&
        navigateToEditPage && (
          <Icon
            height={25}
            icon={"carbon:edit"}
            className="text-orange-500 border border-orange-500 rounded-full p-0.5"
            onClick={navigateToEditPage}
          />
        )}
      {(record?.status == "DRAFT" || name === "announcement" || name === "faq" || name === "users") && (
        <Icon
          height={25}
          icon={"material-symbols:delete-outline"}
          style={{
            color: "var(--Primary-Color, #DA322D)",
            border: "1.25px solid var(--Primary-Color, #DA322D)",
            borderRadius: "50%",
            padding: "2px",
            boxSizing: "border-box",
          }}
          onClick={(e) => {
            e.preventDefault();
            if (name !== "announcement" && name !== "faq" && name !== "users") {
              setSelectedId(record.approvalId);
            }
            setDeleteModalVisible(true);
          }}
        />
      )}
    </div>
  );
};

export const renderUpdatedAtColumn = (text: string) => {
  return text ? <div>{text}</div> : <div>Drupal Admin</div>;
};

export const formatDate = (date?: string | null): string => {
  if (!date) return "-";

  const m = moment(date, ["YYYY-MM-DD", moment.ISO_8601, "DD MMM YYYY"], true);
  return m.isValid() ? m.format("DD MMM YYYY") : "-";
};

export const passengerAirportColumn = (data?: any) => {
  const airportList = [
    { label: "KLIA1", value: "klia1" },
    { label: "KLIA2", value: "klia2" },
    { label: "Langkawi", value: "langkawi" },
    { label: "Penang", value: "penang" },
    { label: "Kuching", value: "kuching" },
    { label: "Kota Kinabalu", value: "kota-kinabalu" },
  ];

  // Helper: Convert data into labels
  const getAirportLabels = (input: string | string[]) => {
    if (!input || input.length === 0) return "-";
    // Normalize input into array
    const arr = Array.isArray(input) ? input : input.split(",").map((v) => v.trim());

    // Map to labels
    return arr.map((val) => airportList.find((a) => a.value === val)?.label || val).join(", ");
  };

  return getAirportLabels(data);
};
